/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AddressUsageType } from './AddressUsageType';
import {
    AddressUsageTypeFromJSON,
    AddressUsageTypeFromJSONTyped,
    AddressUsageTypeToJSON,
    AddressUsageTypeToJSONTyped,
} from './AddressUsageType';

/**
 * 
 * @export
 * @interface AddressOutput
 */
export interface AddressOutput {
    /**
     * domicile country of the partner
     * @type {string}
     * @memberof AddressOutput
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressOutput
     */
    city?: string;
    /**
     * 
     * @type {Array<AddressUsageType>}
     * @memberof AddressOutput
     */
    usageType?: Array<AddressUsageType>;
}

/**
 * Check if a given object implements the AddressOutput interface.
 */
export function instanceOfAddressOutput(value: object): value is AddressOutput {
    return true;
}

export function AddressOutputFromJSON(json: any): AddressOutput {
    return AddressOutputFromJSONTyped(json, false);
}

export function AddressOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddressOutput {
    if (json == null) {
        return json;
    }
    return {
        
        'country': json['country'] == null ? undefined : json['country'],
        'city': json['city'] == null ? undefined : json['city'],
        'usageType': json['usageType'] == null ? undefined : ((json['usageType'] as Array<any>).map(AddressUsageTypeFromJSON)),
    };
}

export function AddressOutputToJSON(json: any): AddressOutput {
    return AddressOutputToJSONTyped(json, false);
}

export function AddressOutputToJSONTyped(value?: AddressOutput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'country': value['country'],
        'city': value['city'],
        'usageType': value['usageType'] == null ? undefined : ((value['usageType'] as Array<any>).map(AddressUsageTypeToJSON)),
    };
}

